import { UnitBusinessVirtualDebitCardDto } from "src/app/shared/models/unit-card/UnitBusinessVirtualDebitCardDto.model";

export enum UnitCardPinAction {
  SET_PIN = 0,
  RESET_PIN = 1,
}

export class UnitCardPinParams {
  unitCardPinAction: UnitCardPinAction;
  cardId: string;
  unitCustomerToken: string;
  businessVirtualDebitCard: UnitBusinessVirtualDebitCardDto;

  constructor(
    _unitCardPinAction: UnitCardPinAction,
    _businessCard: UnitBusinessVirtualDebitCardDto,
    _unitCustomerToken: string
  ) {
    this.unitCardPinAction = _unitCardPinAction;
    this.cardId = _businessCard.unitCardResourceId;
    this.unitCustomerToken = _unitCustomerToken;
    this.businessVirtualDebitCard = _businessCard;
  }
}
